'use client';

import { createBooleanSetting } from './create-boolean-setting';

export const HIGH_PERF_STORAGE_KEY = 'flowmuse:render-all-nodes';
export const HIGH_PERF_EVENT = 'flowmuse:high-performance-mode-changed';

export type HighPerformanceModeChangedDetail = {
  enabled: boolean;
};

/**
 * "Render All Nodes"（高性能模式）开关：
 * - 默认关闭：大画布会虚拟化（卸载）视口外的节点
 * - 开启：渲染全部节点，并让媒体（image/video）也不再按视口懒加载/卸载
 *
 * 改用共享外部 store（createBooleanSetting）：所有订阅者共用一个模块级状态与
 * 单一的一对 window 监听器（首个订阅者挂载时附加、最后一个卸载后移除）。相比旧的
 * "每组件 useState + 自挂监听" 实现，这样即便被画布上数百个媒体节点（useInViewport）
 * 订阅，成本也保持恒定。localStorage key / 事件名保持不变以兼容既有数据与跨标签页同步。
 */
const setting = createBooleanSetting({
  storageKey: HIGH_PERF_STORAGE_KEY,
  eventName: HIGH_PERF_EVENT,
  defaultValue: false,
});

export const readHighPerformanceModeEnabled = setting.read;
export const writeHighPerformanceModeEnabled = setting.write;
export const useHighPerformanceMode = setting.useValue;
